import { render } from "./StartHero.vue?vue&type=template&id=7eaf0d82&scoped=true"
import script from "./StartHero.vue?vue&type=script&lang=js"
export * from "./StartHero.vue?vue&type=script&lang=js"

import "./StartHero.vue?vue&type=style&index=0&id=7eaf0d82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eaf0d82"]])

export default __exports__